module.exports = __webpack_public_path__ + "img/DHAOHA-min.58c48077.png";